import axios from "./axios";

export const createPayPalOrder = async (bookingData) => {
  const response = await axios.post("/paypal/create-order", bookingData);
  return response.data;
};

export const capturePayPalPayment = async (orderId, bookingId) => {
  const response = await axios.post("/paypal/capture-payment", {
    order_id: orderId,
    booking_id: bookingId,
  });
  return response.data;
};

export default {
  createPayPalOrder,
  capturePayPalPayment,
};
